/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://apim-glsit-eva-dev-germanywestcentral-001.azure-api.net/administratives';
}

/**
 * Parameters for `GlsAdministrativeApiInterfaceModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
